<template>
  <div :id="videoPlatformId" class="playWnd" />
</template>
<script>
export default {
  name: 'LoadCamaer',

  props: [
    'videoPlatformId',
    'showButtons',
    'layout',
    'pointCode',
    'renderParams',
    'pageName',
    'callBackFlag',
    'videoWidth',
    'videoHeight',
  ],
  data() {
    return {
      // 声明公用变量
      initCount: 0,
      pubKey: '',
      iframeCount:0,
      // 初始化参数
      initparam: {
        // appKey: "23544861",
        // secret: "YcrqwT4ww4LBiJjKKujZ",
        // apiIp: "115.231.112.236",
        // apiPort: 64321,
        // appKey: '24483400',
        // secret: '1EujShKN77g6p1QuhKPu',
        // apiIp: '115.231.112.227',
        // apiPort: 51111,
        appKey: '24950446',
        secret: '9wHFJ4P7U2AFzMcBuyB3',
        apiIp: '219.153.12.24',
        apiPort: 442,
        layout: this.layout // 这里是来控制你一开始初始化之后的分屏的
      },
      swfHeight: null,
      swfWidth: null,
      oWebControl: null,
      WebControl: null
    }
  },
  mounted() {
    this.initPlugin()
    // 监听resize
    // $(window).resize(() => {
    //   if (this.oWebControl != null) {
    //     this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight)
    //   }
    // })
    // 监听scroll
    $(window).scroll(() => {
      if (this.oWebControl != null) {
        this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight)
      }
    })
  },
  beforeDestroy() {
    // this.$emit("saveLoadInfo");
    // this.getLayout();
    this.closeWindow()
  },
  methods: {
    // 创建播放实例
    initPlugin() {
      this.oWebControl = new WebControl({
        szPluginContainer: this.videoPlatformId, // 指定容器id
        iServicePortStart: 15900, // 指定起止端口号，建议使用该值
        iServicePortEnd: 15909,
        szClassId: '23BF3B0A-2C56-4D97-9C03-0CB103AA8F11', // 用于IE10使用ActiveX的clsid
        cbConnectSuccess: () => {
          // 创建WebControl实例成功
          this.oWebControl
            .JS_StartService('window', {
              // WebControl实例创建成功后需要启动服务
              dllPath: './VideoPluginConnect.dll' // 值"./VideoPluginConnect.dll"写死
            })
            .then(
              () => {
                // 启动插件服务成功
                this.oWebControl.JS_SetWindowControlCallback({
                  // 设置消息回调
                  cbIntegrationCallBack: this.cbIntegrationCallBack // 封装的推送消息方法
                })
                this.oWebControl
                  .JS_CreateWnd(this.videoPlatformId, this.videoWidth, this.videoHeight)
                  .then(() => {
                    // JS_CreateWnd创建视频播放窗口，宽高可设定
                    this.init() // 创建播放实例成功后初始化
                  })
                  .then(() => {
                    this.$emit('initSuccess')
                  })
              },
              function() {
                // 启动插件服务失败
              }
            )
        },
        cbConnectError: () => {
          // 创建WebControl实例失败
          this.oWebControl = null
          try {
            this.WebControl.JS_WakeUp('VideoWebPlugin://') // 程序未启动时执行error函数，采用wakeup来启动程序
          } catch (e) {
            this.$emit('initFailed')
          }
        },
        cbConnectClose: bNormalClose => {
          // 异常断开：bNormalClose = false
          // JS_Disconnect正常断开：bNormalClose = true
          this.oWebControl = null
        }
      })
    },

    cuttingPartWindow(left, top, width, height) {
      this.oWebControl.JS_CuttingPartWindow(left, top, width, height)
    },
    repairPartWindow(left, top, width, height) {
      this.oWebControl.JS_RepairPartWindow(left, top, width, height)
    },

    // 设置窗口控制回调
    setCallbacks() {
      this.oWebControl.JS_SetWindowControlCallback({
        cbIntegrationCallBack: this.cbIntegrationCallBack // 封装的推送消息方法
      })
    },

    // 推送消息
    cbIntegrationCallBack(oData) {
      // oData是封装的视频web插件回调信息的消息体
      console.log(oData) // 此处为视频web插件消息json报文字符串
      this.showCBInfo(oData)
    },

    showCBInfo(data) {
      const backData = Object.assign(data, { domId: this.videoPlatformId })
      this.$emit('clickCamera', backData)
    },

    // 初始化
    init() {
      this.getPubKey(() => {
        // //////////////////////////////// 请自行修改以下变量值	////////////////////////////////////
        var appkey = this.initparam.appKey // 综合安防管理平台提供的appkey，必填
        var secret = this.setEncrypt(this.initparam.secret) // 综合安防管理平台提供的secret，必填
        var ip = this.initparam.apiIp // 综合安防管理平台IP地址，必填
        var playMode = this.renderParams.playMode // 初始播放模式：0-预览，1-回放
        var port = this.initparam.apiPort // 综合安防管理平台端口，若启用HTTPS协议，默认443
        port = parseInt(port)
        var snapDir = 'D:\\SnapDir' // 抓图存储路径
        var videoDir = 'D:\\VideoDir' // 紧急录像或录像剪辑存储路径
        var layout = this.initparam.layout // playMode指定模式的布局
        var enableHTTPS = 1 // 是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
        var encryptedFields = 'secret' // 加密字段，默认加密领域为secret
        var showToolbar = this.renderParams.showToolBar // 是否显示工具栏，0-不显示，非0-显示
        var showSmart = this.renderParams.showSmart // 是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        // var buttonIDs =
        //   "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769"; //自定义工具条按钮
        var buttonIDs = ''
        if (this.showButtons) {
          buttonIDs = '0,16,256,257,258,259,260,512,513,514,515,516,517,768,769'
        }
        // //////////////////////////////// 请自行修改以上变量值	////////////////////////////////////

        this.oWebControl
          .JS_RequestInterface({
            // 通用请求响应接口
            funcName: 'init', // 功能标识
            argument: JSON.stringify({
              appkey: appkey, // API网关提供的appkey
              secret: secret, // API网关提供的secret
              ip: ip, // API网关IP地址
              playMode: playMode, // 播放模式（决定显示预览还是回放界面）
              port: port, // 端口
              snapDir: snapDir, // 抓图存储路径
              videoDir: videoDir, // 紧急录像或录像剪辑存储路径
              layout: layout, // 布局
              enableHTTPS: enableHTTPS, // 是否启用HTTPS协议
              encryptedFields: encryptedFields, // 加密字段
              showToolbar: showToolbar, // 是否显示工具栏
              showSmart: showSmart, // 是否显示智能信息
              buttonIDs: buttonIDs // 自定义工具条按钮
            })
          })
          .then(oData => {
            this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight) // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
            this.startpreview() // 初始化后开启预览
          })
      })
    },

    // 获取公钥
    getPubKey(callback) {
      this.oWebControl
        .JS_RequestInterface({
          // 通用请求响应接口
          funcName: 'getRSAPubKey', // 功能标识
          argument: JSON.stringify({
            keyLength: 1024 // 秘钥长度，可选1024或2048
          })
        })
        .then(oData => {
          if (oData.responseMsg.data) {
            // 当code为-1时无data字段
            this.pubKey = oData.responseMsg.data // 返回的数据，如RSA公钥
            callback()
          }
        })
    },

    // RSA加密
    setEncrypt(value) {
      var encrypt = new JSEncrypt()
      encrypt.setPublicKey(this.pubKey)
      return encrypt.encrypt(value)
    },

    showCameras() {
      this.pointCode.map(item => {
        this.oWebControl.JS_RequestInterface({
          funcName: 'startPreview',
          argument: JSON.stringify({
            cameraIndexCode: item, // 监控点编号
            streamMode: this.renderParams.streamMode, // 主子码流标识
            transMode: this.renderParams.transMode, // 传输协议
            gpuMode: this.renderParams.gpuMode, // 是否开启GPU硬解
            wndId: this.renderParams.wndId // 可指定播放窗口
          })
        })
      })
    },

    paramsToFormData(obj) {
      const formData = new FormData()
      Object.keys(obj).forEach(key => {
        if (obj[key] instanceof Array) {
          obj[key].forEach(item => {
            formData.append(key, item)
          })
          return
        }
        formData.append(key, obj[key])
      })
      return formData
    },

    getLayout() {
      const that = this
      this.oWebControl
        .JS_RequestInterface({
          funcName: 'getLayout'
        })
        .then(res => {
          const parseData = JSON.parse(res.responseMsg.data)
          const winNum = parseData.wndNum
          const layoutMode = parseData.layout
          const pointCode = this.pointCode.slice(0, winNum)
          const postData = {
            pageName: this.pageName,
            layout: layoutMode,
            pointCode: pointCode
          }
          const postDataArray = []
          const formData = new FormData()
          formData.append('content', JSON.stringify(postData))
          // VRModuleInterface.saveLayoutData(formData).then(ress => {
          //   console.log("operation success");
          // });
          // VRModuleInterface.getLayoutData().then(ress => {
          //   console.log("operation success", ress);
          // });
          this.closeWindow()
        })
    },

    // 视频“预览”功能
    startpreview() {
      // 切换视频后得到当前layout
      this.oWebControl
        .JS_RequestInterface({
          funcName: 'getLayout'
        })
        .then(res => {
          const nowPreviewLayout = JSON.parse(res.responseMsg.data)['layout']
          localStorage.setItem('nowPreviewLayout', nowPreviewLayout)
        })
      this.showCameras()
    },

    // 停止全部预览功能
    stopAllPreview() {
      this.oWebControl.JS_RequestInterface({
        funcName: 'stopAllPreview'
      })
    },

    reStartPreview(code) {
      this.oWebControl
        .JS_RequestInterface({
          funcName: 'getLayout'
        })
        .then(res => {
          const nowPreviewLayout = JSON.parse(res.responseMsg.data)['layout']
          localStorage.setItem('nowPreviewLayout', nowPreviewLayout)
        })
      this.oWebControl.JS_RequestInterface({
        funcName: 'startPreview',
        argument: JSON.stringify({
          cameraIndexCode: code, // 监控点编号
          streamMode: this.renderParams.streamMode, // 主子码流标识
          transMode: this.renderParams.transMode, // 传输协议
          gpuMode: this.renderParams.gpuMode, // 是否开启GPU硬解
          wndId: this.renderParams.wndId // 可指定播放窗口
        })
      })
    },

    reStartPreviewSeven(code, wndId) {
      this.oWebControl
        .JS_RequestInterface({
          funcName: 'getLayout'
        })
        .then(res => {
          const nowPreviewLayout = JSON.parse(res.responseMsg.data)['layout']
          localStorage.setItem('nowPreviewLayout', nowPreviewLayout)
        })
      this.oWebControl.JS_RequestInterface({
        funcName: 'startPreview',
        argument: JSON.stringify({
          cameraIndexCode: code, // 监控点编号
          streamMode: this.renderParams.streamMode, // 主子码流标识
          transMode: this.renderParams.transMode, // 传输协议
          gpuMode: this.renderParams.gpuMode, // 是否开启GPU硬解
          wndId: wndId // 可指定播放窗口
        })
      })
    },
    // 视频回放
    backVideo(VideoIndex) {
      let cameraIndexCode = VideoIndex;
      let months = new Date().getMonth() + 1
      let end = new Date().getFullYear() + '/' + months + '/' + new Date().getDate() + ' 00:00:00'
      let endT = String(parseInt(new Date(end).getTime() / 1000));
      let star = String(parseInt(new Date(end).getTime() / 1000 - 3 * 24 * 60 * 60))
      this.oWebControl.JS_RequestInterface({
        funcName: "startPlayback",
        argument: JSON.stringify({
          cameraIndexCode: cameraIndexCode.trim(),    // 监控点编号
          startTimeStamp: star,                       // 录像查询开始时间戳，单位：秒
          endTimeStamp: endT,                         // 录像查询结束时间戳，单位：秒
          recordLocation: 0,                          // 录像存储类型 0-中心存储 1-设备存储
          transMode: 1,                               // 传输协议 ，0-UDP 1-TCP
          gpuMode: 1,                                 // 是否开启 GPU 硬解，0-不开启 1-开启
          wndId: 1                                   //可指定播放窗口
        })
      });
    },

    resizeFresh(iWidth, iHeight,iLeft,iTop,flag) {
      let _this = this
      this.oWebControl && this.oWebControl.JS_Resize(iWidth, iHeight)
      let minILeft = iLeft - 108;
      let maxILeft = iLeft - 253;
      if(!flag && sessionStorage.getItem("outSizeLogin") && sessionStorage.getItem("outSizeLogin")==1){
        if(sessionStorage.getItem("isActive") && sessionStorage.getItem("isActive")==1){
              _this.oWebControl.JS_SetDocOffset({
                left:maxILeft,
                top:iTop+65
              })
        }else{
          if(this.iframeCount == 0){
            if(iWidth>1200){
                _this.oWebControl.JS_SetDocOffset({
                  left:maxILeft,
                  top:iTop+65
                })

            }else{
                _this.oWebControl.JS_SetDocOffset({
                  left:minILeft,
                  top:iTop+65
                })
            }

            this.iframeCount++
          }
          else{
              _this.oWebControl.JS_SetDocOffset({
                left:minILeft,
                top:iTop+65
              })
          }

        }

      }
    },

    hidenWindow() {
      if (this.oWebControl != null) {
        this.oWebControl.JS_HideWnd()
      }
    },

    showWindow() {
      if (this.oWebControl != null) {
        this.oWebControl.JS_ShowWnd()
      }
    },

    // 关闭视频窗口
    closeWindow() {
      if (this.oWebControl != null) {
        this.oWebControl.JS_HideWnd() // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
        this.oWebControl.JS_DestroyWnd()
        this.oWebControl.JS_Disconnect().then(
          () => {
            // 断开与插件服务连接成功
          },
          () => {
            // 断开与插件服务连接失败
          }
        )
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/LoadCamaer.vue